module.exports = __webpack_public_path__ + "media/images/voting_0-580cfca7987b4532daf13f425724568c.svg";